type FileTypeFlags = {
  isImage?: boolean;
  isDocuments?: boolean;
  isScorm?: boolean;
  // Video formats Cloudflare Stream takes (lesson step video)
  isVideo?: boolean;
  // CSV, XLS, XLSX
  isSpreadsheet?: boolean;
};

export const getAcceptTypes = ({
  isImage,
  isDocuments,
  isScorm,
  isVideo,
  isSpreadsheet,
}: FileTypeFlags) => {
  const accept: Record<string, string[]> = {};

  if (isScorm) {
    accept['application/zip'] = ['.zip'];
  }

  if (isImage) {
    accept['image/jpeg'] = ['.jpg', '.jpeg'];
    accept['image/png'] = ['.png'];
  }

  if (isDocuments) {
    accept['application/pdf'] = ['.pdf'];
    accept['application/msword'] = ['.doc'];
    accept['application/vnd.openxmlformats-officedocument.wordprocessingml.document'] = ['.docx'];
  }

  if (isSpreadsheet) {
    accept['text/csv'] = ['.csv'];
    accept['application/vnd.ms-excel'] = ['.xls'];
    accept['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] = ['.xlsx'];
  }

  if (isVideo) {
    accept['video/mp4'] = ['.mp4'];
    accept['video/x-msvideo'] = ['.avi'];
    accept['video/x-matroska'] = ['.mkv'];
    accept['video/quicktime'] = ['.mov'];
    accept['video/x-ms-wmv'] = ['.wmv'];
    accept['video/x-flv'] = ['.flv'];
    accept['video/3gpp'] = ['.3gp'];
    accept['video/mpeg'] = ['.mpeg', '.mpg'];
  }

  return accept;
};

/**
 * Hint text built from the same accept map the dropzone uses, so the hint always lists what is
 * really accepted: "Supported File Types are .jpg, .jpeg, .png, .pdf"
 */
export const formatAcceptHint = (accept: Record<string, readonly string[]>) => {
  const extensions = [...new Set(Object.values(accept).flat())];
  return `Supported File Types are ${extensions.join(', ')}`;
};
